(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-magazine-tiers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('es-magazine-club')) {
    customElements.define(
      'es-magazine-club',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          const options = {
            signal: this.controller.signal
          };

          this.details = this.querySelector('[data-club-details]');
          this.summary = this.querySelector('[data-club-summary]');
          this.scrollArea = this.querySelector('[data-club-scroll]');
          this.hint = this.querySelector('[data-club-hint]');
          this.closeButton = this.querySelector('[data-club-close]');

          if (!this.details || !this.summary || !this.scrollArea) {
            return;
          }

          this.setAttribute('data-club-ready', '');

          this.closeButton?.addEventListener(
            'click',
            () => this.collapse(),
            options
          );

          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape' && this.details.open) {
                event.preventDefault();
                this.collapse();
              }
            },
            options
          );

          this.details.addEventListener(
            'toggle',
            () => this.updateOverflow(),
            options
          );

          if ('ResizeObserver' in window) {
            this.resizeObserver?.disconnect();

            this.resizeObserver = new ResizeObserver(
              () => this.updateOverflow()
            );

            this.resizeObserver.observe(this.scrollArea);
            this.resizeObserver.observe(
              this.scrollArea.firstElementChild
            );
          }

          this.updateOverflow();
        }

        updateOverflow() {
          const overflowing =
            this.scrollArea.scrollWidth >
            this.scrollArea.clientWidth + 2;

          if (this.hint) {
            this.hint.hidden = !overflowing;
          }

          this.scrollArea.tabIndex = overflowing ? 0 : -1;
        }

        collapse() {
          this.details.open = false;
          this.summary.focus({ preventScroll: true });

          this.summary.scrollIntoView({
            behavior: window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches
              ? 'auto'
              : 'smooth',
            block: 'nearest'
          });
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.resizeObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
